import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "interactive" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_progress_bar = _resolveComponent("progress-bar")!
  const _component_tutorial = _resolveComponent("tutorial")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.finished)
      ? (_openBlock(), _createBlock(_component_progress_bar, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.level === 0)
      ? (_openBlock(), _createBlock(_component_tutorial, {
          key: 1,
          onLoad: _ctx.update,
          onScroll: _ctx.scroll
        }, null, 8, ["onLoad", "onScroll"]))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_component_router_view, {
      key: _ctx.$route.fullPath,
      onLoad: _ctx.update,
      onScroll: _ctx.scroll
    }, null, 8, ["onLoad", "onScroll"]))
  ]))
}